import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-remove-diagnostics-family-generation-confirm',
  templateUrl: './remove-diagnostics-family-generation-confirm.component.html',
  styleUrls: ['./remove-diagnostics-family-generation-confirm.component.css']
})
export class RemoveDiagnosticFamilyGenerationConfirmComponent {

  @Input()
  itemToRemoveName: string;

  @Output()
  removeConfirm: EventEmitter<any> = new EventEmitter();

  confirmRemove() {
    this.removeConfirm.emit();
  }
}
